// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconAngleDownActiveCircle: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
            <path
                fill="#4D4D4D"
                d="M7,13.4375 C3.85546875,13.4375 1.3125,10.8945312 1.3125,7.75 C1.3125,4.60546875 3.85546875,2.0625 7,2.0625 C10.1445312,2.0625 12.6875,4.60546875 12.6875,7.75 C12.6875,10.8945312 10.1445312,13.4375 7,13.4375 Z M7,0.75 C3.14453125,0.75 0,3.89453125 0,7.75 C0,11.6054688 3.14453125,14.75 7,14.75 C10.8554688,14.75 14,11.6054688 14,7.75 C14,3.89453125 10.8554688,0.75 7,0.75 Z M3.69140625,7.33984375 L6.53515625,10.1835938 C6.78125,10.4296875 7.21875,10.4296875 7.46484375,10.1835938 L10.3085938,7.33984375 C10.5546875,7.09375 10.5546875,6.65625 10.3085938,6.41015625 C10.0625,6.1640625 9.625,6.1640625 9.37890625,6.41015625 L7,8.7890625 L4.62109375,6.41015625 C4.375,6.1640625 3.96484375,6.1640625 3.69140625,6.41015625 C3.4453125,6.68359375 3.4453125,7.09375 3.69140625,7.33984375 Z"
            />
        </svg>
    );
};

export default React.memo(IconAngleDownActiveCircle);
